import { Typography } from '@weareopenr/component-library';
import { ReactElement } from 'react';
import { formatPrice } from 'src/helpers/formatPrice/formatPrice';
import styles from './Modifier.module.scss';
import { Link } from 'react-router-dom';

export type ModifierProps = {
  posId: string;
  name: string;
  price: number;
  link: string;
  inheritPrice: boolean;
};
const getPrice = (price: number | null, shouldInheritFromParent: boolean) => {
  if (shouldInheritFromParent) {
    return 'Inherited';
  }
  return price !== null ? formatPrice(price) : '-';
};

const getPosId = (posId: string) => {
  if (!posId) {
    return 'Inherited';
  }
  return posId;
};

const Modifier = ({ posId, name, price, link, inheritPrice }: ModifierProps): ReactElement => (
  <div className={styles['modifier-container']}>
    <Link title={name} className={styles['modifier-link']} to={link}>
      {name}
    </Link>
    <div className={styles['inner-container']}>
      <div className={styles['item']}>
        <Typography weight="bold" size="xsmall" className={styles['item-title']}>
          Price
        </Typography>
        <Typography size="xsmall">{getPrice(price, inheritPrice)}</Typography>
      </div>
      <div className={styles['item']}>
        <Typography weight="bold" size="xsmall" className={styles['item-title']}>
          POS ID
        </Typography>
        <Typography size="xsmall">{getPosId(posId)}</Typography>
      </div>
    </div>
  </div>
);

export default Modifier;
